(() => {
    const GRID_SEL = 'ul#product-grid, ul[id^="product-grid"], .product-grid';
    const qp = new URLSearchParams(location.search);
    let rawFirst = (qp.get('first') || "").trim();
    if (!rawFirst) return;

    let firstHandle = rawFirst.split('/').pop().split('?')[0];
    const variantID = /^\d+$/.test(qp.get('variant')) ? qp.get('variant') : "";
    
    let source = (qp.get('source') || "").trim();
    if (!source) {
        const p = location.pathname.split('/').filter(Boolean);
        if (p[0] === 'collections' && p[1]) source = p[1];
    }
    if (!source) return;

    const limit = Math.max(1, parseInt(qp.get('limit') || '24', 10));
    const grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    // FORCE PORTRAIT VIEW: This prevents the "tiny square" issue
    const view = 'card-portrait'; 

    const fetchCard = async (handle, variant = "") => {
        const url = `/products/${encodeURIComponent(handle)}?view=${view}${variant ? `&variant=${variant}` : ""}`;
        try {
            const r = await fetch(url);
            return r.ok ? await r.text() : "";
        } catch(e) { return ""; }
    };

    (async () => {
        // 1. Fetch the Pinned Product first
        const pinnedHTML = await fetchCard(firstHandle, variantID);
        
        // 2. Fetch the rest of the collection data
        const handlesURL = `/collections/${encodeURIComponent(source)}/products.json?limit=250`;
        let restHandles = [];
        try {
            const response = await fetch(handlesURL);
            if (response.ok) {
                const data = await response.json();
                const allHandles = (data.products || []).map(p => p.handle);
                const seen = new Set([firstHandle]);
                for (const h of allHandles) {
                    if (h && !seen.has(h)) {
                        seen.add(h);
                        restHandles.push(h);
                    }
                    if (restHandles.length >= (limit - 1)) break;
                }
            }
        } catch (e) {}

        // 3. Fetch all other cards
        const otherCards = await Promise.all(restHandles.map(h => fetchCard(h)));

        // 4. BATCH RENDER: This reduces the "flicker" by updating the grid all at once
        const finalHTML = [pinnedHTML, ...otherCards].join('');
        grid.style.opacity = '0'; // Hide briefly
        grid.innerHTML = finalHTML;
        
        // 5. Final Image/Link Polish
        if (variantID) {
            const prod = await fetch(`/products/${firstHandle}.js`).then(r => r.json());
            const varObj = prod.variants.find(v => String(v.id) === variantID);
            const pinnedLi = grid.querySelector('li.grid__item:first-child');
            if (varObj && varObj.featured_image && pinnedLi) {
                pinnedLi.querySelectorAll('img').forEach(img => {
                    img.removeAttribute('srcset');
                    img.src = varObj.featured_image.src;
                });
            }
        }
        
        grid.style.transition = 'opacity 0.3s ease';
        grid.style.opacity = '1'; // Fade in everything together
    })();
})();